//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    employee: {
      type: Object,
      default () {
        return {}
      }
    },
    mobile: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      initialized: false,
      opened: false
    }
  },
  computed: {
    notMobile: function () {
      return !this.mobile
    },
    employeeCardUrl: function () {
      return this.$d_getUrlObjectCard(this.employee.id, 'employee')
    }
  },
  watch: {
    employee: function () {
      this.prepareEmployeeImage()
    }
  },
  created: function () {
    this.prepareEmployeeImage()
  },
  methods: {
    prepareEmployeeImage: function () {
      if (this.employee && this.employee.imageId) {
        this.employee.imageUrl = '/service/delta/document/thumbnail/' + this.employee.imageId + '/78/104'
      }

      this.initialized = true
    },
    onOpenWhatsAppInNewTab: function () {
      const url = 'https://wa.me/' + this.convertPhoneNumberForWhatsApp(this.employee.phone1)
      window.open(url)
    },
    onOpenInMail: function () {
      location.href = 'mailto:' + this.employee.email
    },
    convertPhoneNumberForWhatsApp: function (phoneNumber) {
      return this.setCharAt(phoneNumber, 0, '7')
    },
    setCharAt: function (str, index, chr) {
      if (index > str.length - 1) {
        return str
      } else {
        return str.substr(0, index) + chr + str.substr(index + 1)
      }
    }
  }
}

